import { SUPPLIERS_STATUSES } from '~/connect/schemas';
import {
  IAnonymizedSupplierPlatform,
  ICriteriaList,
  ICriteriaUsageVariable,
  IWheelSupplierTemplate,
  IWheelSupplierTemplateForm,
  IWheelSupplierTemplatePayload,
} from '~/connect/types';
import { SupplierTemplateUtils } from '~/connect/helpers';

export const rawToForm = (
  supplierTemplate: IWheelSupplierTemplate,
): IWheelSupplierTemplateForm => {
  return {
    ...supplierTemplate,
    suppliers: supplierTemplate.suppliers.map((supplier) => ({
      ...supplier,
      enabled: supplier.status === SUPPLIERS_STATUSES.ENABLED,
    })),
    criteria: supplierTemplate.criteria.map((associatedCriterion) => ({
      ...associatedCriterion,
      values: associatedCriterion.values.map(
        (associatedCriterionValue) => associatedCriterionValue.id,
      ),
    })),
  };
};

export const formToPayload = (
  formData: IWheelSupplierTemplateForm,
  allCriteria: ICriteriaList['data'],
): IWheelSupplierTemplatePayload => {
  return {
    ...formData,
    criteria: formData.criteria.map((associatedCriterion) => ({
      ...associatedCriterion,
      values: SupplierTemplateUtils.getCriterionValuesByIds(
        associatedCriterion.criterion.id,
        associatedCriterion.values,
        allCriteria,
      ),
    })),
  };
};

export const groupByLetter = (
  suppliers: Array<IAnonymizedSupplierPlatform>,
): Record<string, Array<IAnonymizedSupplierPlatform>> => {
  const grouped: Record<string, Array<IAnonymizedSupplierPlatform>> = {};
  for (const anonymized of suppliers) {
    const letter =
      anonymized.supplierPlatform.supplier.name[0]?.toUpperCase() ?? '#';
    if (!grouped[letter]) {
      grouped[letter] = [];
    }
    grouped[letter].push(anonymized);
  }
  return grouped;
};

export function fromFormToQuery(
  id: string,
  data: IWheelSupplierTemplateForm,
): ICriteriaUsageVariable {
  return {
    id: id,
    query: {
      criteria: data.criteria.map(({ criterion, values }) => ({
        criterion: criterion.id,
        values: values,
      })),
    },
  };
}
